import React from 'react'
import { Modal, Box, IconButton } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import { styled } from '@mui/system'
import CloseIcon from '@mui/icons-material/Close'

// Styled components
const StyledModal = styled(Modal)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end', // This ensures content stays on the right
})

const SheetContent = styled(Box)(({ theme }) => ({
	width: '100%',
	height: '100%',
	backgroundColor: '#fff',
	boxShadow: '-4px 0 12px rgba(0, 0, 0, 0.1)',
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	marginLeft: 'auto', // This ensures the sheet stays on the right
	'@media (min-width: 600px)': {
		width: '800px',
	},
}))

const SheetHeader = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '16px 24px',
	borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
})

const SheetFooter = styled(Box)({
	padding: '16px 24px',
	borderTop: '1px solid rgba(0, 0, 0, 0.1)',
	marginTop: 'auto',
})

const SheetTitle = styled('h2')({
	margin: 0,
	fontSize: '16px',
	fontWeight: 500,
})

const SheetDescription = styled('p')({
	margin: '4px 0 0',
	fontSize: '14px',
	color: 'rgba(0, 0, 0, 0.6)',
})

const SheetBody = styled(Box)({
	padding: '24px',
	overflow: 'auto',
})

const CloseButton = styled(IconButton)({
	position: 'absolute',
	right: '16px',
	top: '12px',
	color: 'rgba(0, 0, 0, 0.6)',
	'&:hover': {
		color: 'rgba(0, 0, 0, 0.8)',
	},
})

const Sheet = ({ open, onClose, title, description, children, footer }) => {
	return (
		<StyledModal
			open={open}
			onClose={onClose}
			BackdropProps={{
				sx: {
					backgroundColor: 'rgba(0, 0, 0, 0.4)',
				},
			}}
		>
			<AnimatePresence>
				{open && (
					<motion.div
						initial={{ x: '100%', opacity: 0 }}
						animate={{ x: 0, opacity: 1 }}
						exit={{ x: '100%', opacity: 0 }}
						transition={{
							type: 'spring',
							damping: 30,
							stiffness: 300,
							opacity: { duration: 0.2 },
						}}
						style={{
							width: '100%',
							height: '100%',
							marginLeft: 'auto', // Ensures the animation starts and ends on the right
							position: 'relative', // Added to maintain right positioning
						}}
					>
						<SheetContent>
							<SheetHeader>
								<div>
									{title && <SheetTitle>{title}</SheetTitle>}
									{description && (
										<SheetDescription>{description}</SheetDescription>
									)}
								</div>
								<CloseButton onClick={onClose} size="small">
									<CloseIcon fontSize="small" />
								</CloseButton>
							</SheetHeader>

							<SheetBody>{children}</SheetBody>

							{footer && <SheetFooter>{footer}</SheetFooter>}
						</SheetContent>
					</motion.div>
				)}
			</AnimatePresence>
		</StyledModal>
	)
}
export { Sheet }
